<template>
  <section class="privacy-banner" aria-label="Privacidad de tu historia">
    <div class="container">
      <div class="privacy-banner__content">
        <HomeNoAiMark />
        <div class="privacy-banner__text">
          <h2 class="privacy-banner__title">Tu historia es solo tuya</h2>
          <p class="privacy-banner__description">
            Ninguna inteligencia artificial tiene acceso a tu obra. Solo tú puedes leerla y
            editarla. Tu manuscrito jamás se usa para entrenar modelos de IA.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import HomeNoAiMark from './HomeNoAiMark.vue'

export default defineComponent({
  name: 'HomePrivacyBanner',

  components: {
    HomeNoAiMark,
  },
})
</script>

<style scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.privacy-banner {
  padding: 2.75rem 0;
  background: linear-gradient(135deg, #1d3557 0%, #457b9d 100%);
  color: white;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.12);
}

.privacy-banner__content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.35rem;
  text-align: left;
  max-width: 760px;
  margin: 0 auto;
}

.privacy-banner__title {
  font-size: 1.45rem;
  font-weight: 700;
  color: white;
  margin: 0 0 0.4rem;
}

.privacy-banner__description {
  margin: 0;
  color: rgba(255, 255, 255, 0.92);
  line-height: 1.55;
  font-size: 1.05rem;
}

@media (max-width: 768px) {
  .container {
    padding: 0 1rem;
  }

  .privacy-banner__content {
    flex-direction: column;
    text-align: center;
    gap: 0.85rem;
  }
}
</style>
